<template>
  <div id="content">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="page-header">
            <h1>Events</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="row has-sidebar">
            <div class="col-md-5 col-lg-4 col-xl-4 col-sidebar">
              <div id="sidebar" class="sidebar-left">
                <div class="sidebar_inner">
                  <div class="card shadow agent-search">
                    <h3 class="subheadline mt0">Filter</h3>
                    <div class="form-group">
                      <label for="location">Enter Title</label>
                      <input type="text" class="form-control" v-model="filterByTitle"
                        placeholder="Show title...">
                    </div>
                    <div class="form-group">
                      <label for="type">Event Type</label>
                      <select v-model="filterByEventType" class="form-control ui-select">
                        <option value="null"> Select type... </option>
                        <option v-for="(eventTypeKey, index) in Object.keys(eventTypeKeyOptions)"
                          :key="index" :value="eventTypeKeyOptions[eventTypeKey]">
                          {{ eventTypeKey.replace(/_/g, ' ') }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label for="dealing">Event Topic</label>
                      <select name="topic_cd" v-model="filterByEventTopic"
                        class="form-control ui-select">
                        <option value="null"> Select topic... </option>
                        <option v-for="(eventTopicKey, index) in Object.keys(eventTopicKeyOptions)"
                          :key="index" :value="eventTopicKeyOptions[eventTopicKey]">
                          {{ eventTopicKey.replace(/_/g, ' ') }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-7 col-lg-8 col-xl-8">
              <div class="item-listing list">
                <div class="item" v-for="(event) in paginatedEvents" :key="event.id">
                  <EventRow
                    :event="event"
                  />
                </div>

                <b-alert show v-show="totalEvents == 0 && !loadingEvents">
                  <h6> There are no events available. </h6>
                </b-alert>

                <b-alert show v-show="loadingEvents">
                  <h6> Loading Events </h6>
                </b-alert>
              </div>

              <div class="text-center" v-show="totalEvents > 0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalEvents"
                  :per-page="perPage"
                  @imput="events"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <script v-html="eventStructuredData" type="application/ld+json" />
  </div>
</template>

<script>
import moment from 'moment-timezone'
import EventRow from '../common/EventRow.vue'
import StructuredData from '../common/StructuredData'

export default {
  name: 'EventsList',
  mixins: [StructuredData],
  components: {
    EventRow
  },
  data: function () {
    return {
      currentPage: 1,
      perPage: 10,
      eventTypeKeyOptions: {},
      eventTopicKeyOptions: {},
      filterByTitle: '',
      filterByEventType: '',
      filterByEventTopic: '',
      events: [],
      moment: moment,
      eventStructuredData: {},
      loadingEvents: true
    }
  },
  created () {
    this.loadEventStructuredData()
    this.getEventTypeKeyOptions()
    this.getEventTopicKeyOptions()
    this.getEvents()
  },
  computed: {
    filteredEvents () {
      var self = this

      if (this.filterByTitle || this.filterByEventType || this.filterByEventTopic ||
          this.filterByStartsAt || this.filterByEndsAt || this.currentPage) {
        var title = new RegExp(this.filterByTitle, 'i')

        return this.events.filter((event) => {
          var filterResult = true

          if (self.filterByTitle.length > 0) {
            filterResult = event.title.match(title)
          }

          if (parseInt(self.filterByEventType) >= 0) {
            filterResult = event.event_type_cd === self.filterByEventType && filterResult
          }

          if (parseInt(self.filterByEventTopic) >= 0) {
            filterResult = event.topic_cd === self.filterByEventTopic && moment(event.starts_at)
          }

          return filterResult
        })
      } else {
        return this.events
      }
    },
    paginatedEvents: function () {
      let indexFrom = (this.currentPage - 1) * this.perPage
      let indexTo = this.perPage * (this.currentPage - 1) + this.perPage
      return this.filteredEvents.slice(indexFrom, indexTo)
    },
    totalEvents () {
      return this.filteredEvents.length
    }
  },
  methods: {
    getEvents: function () {
      var self = this
      var loader = this.$loading.show()

      this.$http.get('public_access/events').then(function (response) {
        self.events = response.data
      }).finally(function () {
        self.loadingEvents = false
        loader.hide()
      })
    },
    getEventTypeKeyOptions () {
      var self = this

      this.$http.get('public_access/events/available_types').then(function (response) {
        self.eventTypeKeyOptions = response.data.event_types
      })
    },
    getEventTopicKeyOptions () {
      var self = this

      this.$http.get('public_access/events/available_topics').then(function (response) {
        self.eventTopicKeyOptions = response.data.event_topics
      })
    }
  }
}
</script>
